import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, Box, Divider, Paper, Typography } from "@mui/material";

type Props = {
  open: boolean;
  title: string;
  text: string[];
  handleClose: () => void;
  handleDelete: () => void;
};

type PropsMap = {
  texto: string[];
};



export default function ConfirmDialogList({
  open,
  title,
  text,
  handleClose,
  handleDelete,
}: Props) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title"></DialogTitle>
      <DialogContent>

        <DialogContentText id="alert-dialog-description">
          <Box>
            <Typography color="primary" variant="h6" component="h6">
              {title}
            </Typography>
          </Box>

          <Divider sx={{ padding: "0.5em", mb: "0.5em" }} textAlign="left" />

          {text.map((v, i) => (
            <Box key={i} sx={{ mb: i === 0 ? "1.5em" : "0" }}>
              <Typography key={i} variant={i === 0 ? "subtitle1" : "body1"} component="p">
                {v.toString()}
              </Typography>
            </Box>
          ))}
          <Divider sx={{ padding: "0.5em", mb: "0.5em" }} textAlign="left" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Não</Button>
        <Button color="secondary" onClick={handleDelete}>
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
}
